import {
  AccountCircleOutlined,
  DescriptionOutlined,
  FolderOutlined,
  HelpOutlineRounded,
  ListAltRounded,
  ShowChartRounded,
  LibraryBooksOutlined
} from '@material-ui/icons';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccountRounded';
import { TFunction } from 'i18next';
import i18n from '../i18n';
import SchemaOutlined from '../icon/SchemaOutlined';
import DashboardPic from './../assets/Dashboard.png';
import DocumentPic from './../assets/Document.png';
import MasterDataPic from './../assets/MasterData.png';
import MyTaskPic from './../assets/MyTask.png';
import WorkflowPic from './../assets/Workflow.png';

interface SystemMenuProps {
  label: string;
  feature: string;
  to: string;
  icon: any;
  isActive: boolean;
}
interface AllMenuProps extends SystemMenuProps {
  noti: number;
  permission?: string;
  src?: any;
}

export const getTranslatedAllMenu = (t: TFunction): AllMenuProps[] => [
  {
    label: t('menu.myTasks.label'),
    feature: t('menu.myTasks.feature'),
    to: '/my-tasks',
    icon: <DescriptionOutlined />,
    noti: 0,
    src: MyTaskPic,
    isActive: true
  },
  {
    label: t('menu.projects.label'),
    feature: t('menu.projects.feature'),
    to: '/projects',
    icon: <FolderOutlined />,
    noti: 0,
    src: DocumentPic,
    isActive: true
  },
  {
    label: t('menu.dashboard.label'),
    feature: t('menu.dashboard.feature'),
    to: '/dashboards',
    icon: <ShowChartRounded />,
    noti: 0,
    src: DashboardPic,
    isActive: true
  },
  {
    label: t('menu.standardWorkflow.label'),
    feature: t('menu.standardWorkflow.feature'),
    to: '/standard-workflows',
    icon: <SchemaOutlined />,
    noti: 0,
    src: WorkflowPic,
    isActive: true
  },
  {
    label: t('menu.documentMasterList.label'),
    feature: t('menu.documentMasterList.feature'),
    to: '/document-master-list',
    icon: <LibraryBooksOutlined />,
    noti: 0,
    src: DocumentPic,
    isActive: true
  },
  {
    label: t('menu.masterData.label'),
    feature: t('menu.masterData.feature'),
    to: '/master-data',
    icon: <ListAltRounded />,
    noti: 0,
    src: MasterDataPic,
    permission: 'documentManagement.masterData.access',
    isActive: true
  }
];

// Keep the original for backward compatibility but now use translated versions
export const ALL_MENU: AllMenuProps[] = getTranslatedAllMenu(i18n.t);

export const showBadge: boolean = getTranslatedAllMenu(i18n.t).some((menu) => menu.noti > 0);

export const getTranslatedSystemMenu = (t: TFunction): SystemMenuProps[] => [
  {
    label: t('menu.myAccount.label'),
    feature: '',
    to: '/account',
    icon: <AccountCircleOutlined />,
    isActive: true
  },
  {
    label: t('menu.help.label'),
    feature: '',
    to: '/helps',
    icon: <HelpOutlineRounded />,
    isActive: true
  },
  {
    label: t('menu.tutorial.label'),
    feature: '',
    to: '/tutorials',
    icon: <SupervisorAccountIcon />,
    isActive: false
  }
];

// Keep the original for backward compatibility but now use translated versions
export const SYSTEM_MENU: SystemMenuProps[] = getTranslatedSystemMenu(i18n.t);
